module.exports = __webpack_public_path__ + "img/up.478f5b43.png";